import { useState } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/daek9ehtto0ceqqngv20';

export default function Subscribe() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'ok' | 'error'>('idle');
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');

  const submit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    // honeypot: silently swallow bot submissions (show normal success, send nothing)
    const honeypot = String(data.get('contact_alt') || '').trim();
    if (honeypot) {
      setStatus('ok');
      setMessage('订阅成功！新料更新时会第一时间邮件通知你。');
      setEmail('');
      form.reset();
      return;
    }

    const params = new URLSearchParams();
    data.forEach((v, k) => {
      if (k !== 'contact_alt') params.append(k, String(v));
    });

    setStatus('loading');
    try {
      const res = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const text = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(text);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text;
      const okCode = parsed?.code === 'OK' || parsed?.code === 'ok';
      const spamish = /spam/i.test(String(serverMsg || ''));
      if (res.ok && okCode && !spamish) {
        setStatus('ok');
        setMessage('订阅成功！新料更新时会第一时间邮件通知你。');
        setEmail('');
        form.reset();
      } else {
        setStatus('error');
        setMessage(spamish || !res.ok ? '提交未成功，请稍后重试或检查邮箱格式。' : serverMsg || '提交未成功，请稍后重试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络异常，订阅未完成，请稍后再试。');
    }
  };

  return (
    <section id="subscribe" className="relative overflow-hidden bg-primary-600 py-16 md:py-20">
      <div className="pointer-events-none absolute -left-16 top-0 h-64 w-64 rounded-full bg-primary-500 blur-2xl"></div>
      <div className="pointer-events-none absolute -right-10 bottom-0 h-56 w-56 rounded-full bg-accent-600/40 blur-2xl"></div>

      <div className="relative mx-auto grid max-w-6xl grid-cols-1 items-center gap-8 px-4 md:px-6 lg:grid-cols-2">
        <div>
          <p className="font-display text-sm uppercase tracking-[0.2em] text-background-50/80">
            Stay Tuned
          </p>
          <h2 className="mt-3 font-heading text-2xl font-black leading-snug text-background-50 md:text-3xl">
            蹲后续，别错过下一颗瓜
          </h2>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-100 md:text-[15px]">
            留下邮箱，88余波一有当事人回应、续集爆料或关键反转，我们会第一时间整理并通知你，
            让你永远快人一步、不错过剧情节点。
          </p>
        </div>

        <div className="rounded-lg bg-background-50 p-5 shadow-soft md:p-6">
          {status === 'ok' ? (
            <div className="flex flex-col items-center py-6 text-center">
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-accent-100 text-2xl text-accent-900">
                <i className="ri-check-double-line"></i>
              </span>
              <p className="mt-4 text-sm font-semibold text-foreground-950">{message}</p>
              <p className="mt-1 text-sm text-foreground-600">记得留意邮箱里的更新邮件哦。</p>
            </div>
          ) : (
            <>
              <p className="text-sm font-semibold text-foreground-950">订阅蹲后续提醒</p>
              <p className="mt-1 text-xs text-foreground-600">随时可退订，我们不会向第三方共享你的邮箱。</p>
              <form
                data-readdy-form="gua88-subscribe"
                onSubmit={submit}
                className="mt-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-0 sm:rounded-full sm:border sm:border-background-300 sm:p-1.5"
              >
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="请输入你的邮箱"
                  className="w-full rounded-full border border-background-300 bg-background-100/60 px-4 py-3 text-sm text-foreground-950 outline-none placeholder:text-foreground-400 focus:border-primary-300 sm:border-0 sm:bg-transparent sm:py-2.5"
                />
                {/* honeypot */}
                <input
                  type="text"
                  name="contact_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="form-website-marker"
                />
                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="shrink-0 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-70 sm:py-2.5"
                >
                  {status === 'loading' ? '提交中…' : '订阅更新'}
                </button>
              </form>
              {status === 'error' && (
                <p className="mt-3 flex items-start gap-1.5 text-sm text-primary-600">
                  <i className="ri-error-warning-line mt-0.5"></i>
                  {message}
                </p>
              )}
              <p className="mt-3 text-[11px] leading-relaxed text-foreground-500">
                提交即表示同意接收本站的追更邮件。内容均基于公开信息整理，最终以官方与当事人说法为准。
              </p>
            </>
          )}
        </div>
      </div>
    </section>
  );
}